export default __webpack_public_path__ + "static/media/s663-7.aeb02752.png";